import {
  SET_CAMPAIGN,
  SET_CAMPAIGN_APPLICATIONS_PROFILE_LIST,
  SET_CAMPAIGN_CLIENTS_PROFILE_LIST,
  SET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST,
  SET_CAMPAIGN_ERROR, SET_CAMPAIGN_FORMAT_PROFILE_LIST, SET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST,
  SET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST,
  SET_CAMPAIGN_SOURCE_PROFILE_LIST, SET_CAMPAIGN_STATUS_PROFILE_LIST
} from "./actionTypes";

const INIT_STATE = {
  data: [],
  isError: false,
  clientData: [],
  appData: [],
  offerTypeData: [],
  sourceData: [],
  directionTypeData: [],
  statusData: [],
  mediaBuyerData: [],
  formatData: [],
}

const CampaignInfo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CAMPAIGN:
      return {
        ...state,
        data: action.payload
      }
    case SET_CAMPAIGN_ERROR:
      return {
        ...state,
        isError: action.payload
      }
    case SET_CAMPAIGN_CLIENTS_PROFILE_LIST:
      return {
        ...state,
        clientData: action.payload
      }
    case SET_CAMPAIGN_APPLICATIONS_PROFILE_LIST:
      return {
        ...state,
        appData: action.payload
      }
    case SET_CAMPAIGN_OFFER_TYPE_PROFILE_LIST:
      return {
        ...state,
        offerTypeData: action.payload
      }
    case SET_CAMPAIGN_SOURCE_PROFILE_LIST:
      return {
        ...state,
        sourceData: action.payload
      }
    case SET_CAMPAIGN_DIRECTION_TYPE_PROFILE_LIST:
      return {
        ...state,
        directionTypeData: action.payload
      }
    case SET_CAMPAIGN_STATUS_PROFILE_LIST:
      return {
        ...state,
        statusData: action.payload
      }
    case SET_CAMPAIGN_MEDIA_BUYER_PROFILE_LIST:
      return {
        ...state,
        mediaBuyerData: action.payload
      }
    case SET_CAMPAIGN_FORMAT_PROFILE_LIST:
      return {
        ...state,
        formatData: action.payload
      }
    default:
      return state
  }
}

export default CampaignInfo;
